export default "__VITE_ASSET__jYroooa$__"